module.exports = __webpack_public_path__ + "img/mp3-player.e646a766.svg";